module.exports = __webpack_public_path__ + "assets/b5aa896911d6fc6d3b03656efc033b47.svg";